// extracted by mini-css-extract-plugin
module.exports = {"alert":"alert_alert__Sr0tj","error":"alert_error__Me6ao","success":"alert_success__34ujX","info":"alert_info__1f9s7"};